import { render } from "./SemEventoBanner.vue?vue&type=template&id=fbfa43fc&scoped=true"
import script from "./SemEventoBanner.vue?vue&type=script&lang=js"
export * from "./SemEventoBanner.vue?vue&type=script&lang=js"

import "./SemEventoBanner.vue?vue&type=style&index=0&id=fbfa43fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbfa43fc"]])

export default __exports__